import React from 'react';
import { CtaButton } from './CtaButton';
import { BoardMotif } from './BoardMotif';
import { ProductVisual } from './ProductVisual';
const chips = ['6 Volumes', '5 Bonuses', '129 Experiment Cards', '29 Worksheets', 'Individual & group work'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it or keep it on a tablet'];
export function Hero() {
  return <section className="paper-ground relative w-full overflow-hidden border-b-4 border-sage" data-id="element-117" data-mp="129qwbqwlhzqi">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-118" data-mp="xa4hjd14cbfl">
        <BoardMotif className="absolute -right-20 -top-16 h-[280px] w-[280px] text-teal/15 sm:h-[380px] sm:w-[380px]" data-id="element-119" data-mp="sb1a5lxo1t4g" />
      </div>

      <div className="relative z-10 mx-auto max-w-6xl px-5 pb-14 pt-7 sm:pb-20 sm:pt-10" data-id="element-120" data-mp="nb6lzq59zhn3">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-121" data-mp="3d1sayygxbltn">
          <div data-id="element-122" data-mp="381xlmzcsr4ap">
            <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-123" data-mp="381e1rd3l65u1">
              For Gestalt therapists &amp; Gestalt-trained counselors
            </p>
            <h1 className="mt-3 font-display text-[34px] leading-[1.08] text-sage sm:text-5xl md:text-6xl" data-id="element-124" data-mp="3o859n6oa5t2g">
              Never walk into a session wondering{' '}
              <em className="text-terra-deep" data-id="element-125" data-mp="39cpcutwbfj2d">what experiment to offer.</em>
            </h1>
            <p className="mt-5 max-w-xl text-base text-ink-soft sm:text-lg" data-id="element-126" data-mp="3ebisarv5xk56">
              Gestalt Session Ready is a six-volume library of 129 Experiment
              Cards &mdash; each with when to offer it, the exact offer line, a
              gentler and a stronger version, and the closing questions. Not
              recipes: a map from the figure in the room to the experiment you
              offer, for individual and group work.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-127" data-mp="2hk84a0c7fpfn">
              {chips.map(chip => <li key={chip} className="rounded-full border border-sage/25 bg-white/70 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-sage" data-id="element-128" data-mp="2ll0i76w0uii9">
                  {chip}
                </li>)}
            </ul>
          </div>

          <ProductVisual eager data-id="element-129" data-mp="id9tudnwcbtt" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-130" data-mp="i9vpizvo9sjq">
          <div className="w-full max-w-md" data-id="element-131" data-mp="dege0el508qh">
            <CtaButton data-id="element-132" data-mp="1b0vx1kt7peg5">Get the library</CtaButton>
          </div>

          <div className="mt-5 w-full max-w-md rounded-2xl border border-sand-dark bg-white/80 px-4 py-3.5 text-center" data-id="element-133" data-mp="1b0dts484tzyq">
            <p className="chalk-note text-[17px] leading-snug text-sage" data-id="element-134" data-mp="15zzubakljycb">
              You don’t plan the experiment. You prepare the map.
            </p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-135" data-mp="x032j02wujd1">
              Notice · Name · Grade · Offer · Assimilate
            </p>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-ink-soft" data-id="element-136" data-mp="3hr3s5wvh8d6c">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-137" data-mp="1xb5qyhfqoxhp">
                <span className="h-1.5 w-1.5 rounded-full bg-terra" data-id="element-138" data-mp="21by07aom32dz" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}